import { css } from 'lit';

export const style = css`
  .spacer {
    margin-top: 1rem;
  }

  .subheader {
    line-height: 24px;
    margin-bottom: 16px;
  }

  .card {
    display: grid;
    flex-grow: 1;
    gap: 1rem;
    grid-auto-flow: row;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    margin-top: 1rem;
  }
`;
